<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="border border-gray-100 rounded-xl p-5 shadow-sm">
        <b-skeleton animation="wave" width="40%" height="16px" class="mb-2"></b-skeleton>
        <b-skeleton animation="wave" width="80px" height="48px"></b-skeleton>
      </div>
    </template>
    <div class="border border-gray-100 rounded-xl p-5 shadow-sm">
      <div class="flex justify-between items-start mb-2">
        <span class="text-gray-700 font-medium">Intentos</span>
      </div>
      <div class="text-5xl font-bold text-gray-900 mb-2">
        {{ kpiData.count }}
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getCourseTotalAttemptsKpi } from '@/services/CourseStats.service';

export default {
  name: 'CourseTotalAttemptsKpi',

  data() {
    return {
      loading: true,
      kpiData: {
        count: 0
      }
    };
  },

  props: {
    courseId: {
      type: Number,
      required: true,
      default: 0
    },
    isPremium: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    courseId(newValue) {
      // No cargar datos si no es premium
      if (!this.isPremium) {
        return;
      }
      this.fetchKpiData(newValue)
    },
    isPremium(newValue) {
      // Si el usuario se vuelve premium, cargar los datos
      if (newValue && this.courseId) {
        this.loading = true;
        this.fetchKpiData(this.courseId);
      }
    }
  },

  created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (!this.isPremium) {
      this.loading = true;
      return;
    }
    
    this.fetchKpiData(this.courseId);
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (!this.isPremium) {
      this.loading = true;
    }
  },

  methods: {
    async fetchKpiData(courseId) {
      if (!courseId || !this.isPremium) return;
      
      this.kpiData = await getCourseTotalAttemptsKpi(courseId);
      this.loading = false; // Ocultar skeleton inmediatamente después de cargar
    }
  },
}
</script>